import websiteJson from '../../../config/website.json';
import { apiDomain } from '../appConfig';
import urlParser from '../urlParser';

const wordingUri = () => {
	if (!process.env.DEV) {
		return `${apiDomain}/wording`;
	}

	if (window.location.hostname === 'localhost') {
		return `//localhost:${websiteJson.port.wordingServer}`;
	}

	return `${
		websiteJson.domain.demo.main.ssl ? 'https' : 'http'
	}://${
		websiteJson.domain.demo.main.value
	}/wording`;
};

const wordingJson = (page = 'common') => (
	fetch(`${
		wordingUri()
	}/${urlParser.branch}/${urlParser.language}/${page}?h=${process.env.HASH}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default wordingJson;



// WEBPACK FOOTER //
// ./src/js/request/wordingJson.js